import React from 'react';

import { IconButton } from '@mui/material';
import { ArrowUp } from 'lucide-react';
import { AddContextButton } from 'src/components/ai/chat/ChatPanel/AlineMarkdownEditor/add-context-button';
import { AlineTooltip } from 'src/components/generic/AlineTooltip';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  footer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1, 1, 1),
  },
  iconButton: {
    padding: theme.spacing(0.25),
  },
  submitButton: {
    color: theme.appColors.iconsType,
  },
}));

interface ActivityEditorFooterProps {
  onOpenMentions: () => void;
  mentionDisabled?: boolean;
  onSubmit?: () => void;
  showSubmit?: boolean;
  submitDisabled?: boolean;
  submitTooltip?: string;
}

export function ActivityEditorFooter({
  mentionDisabled = false,
  onOpenMentions,
  onSubmit,
  showSubmit = true,
  submitDisabled = false,
  submitTooltip = 'Submit',
}: ActivityEditorFooterProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.footer}>
      <AddContextButton disabled={mentionDisabled} onClick={onOpenMentions} />
      {showSubmit && onSubmit && (
        <AlineTooltip arrow placement="top" title={submitTooltip}>
          <span>
            <IconButton
              aria-label={submitTooltip}
              className={`${classes.iconButton} ${classes.submitButton}`}
              disabled={submitDisabled}
              size="small"
              onClick={onSubmit}
            >
              <ArrowUp size={16} />
            </IconButton>
          </span>
        </AlineTooltip>
      )}
    </div>
  );
}
